<template>
  <div>
    <el-dialog title="添加示例图" :visible.sync="visible" :close-on-click-modal="false" width="600px">
      <el-form ref="formRef" :model="formData" :rules="formRule" label-width="148px">
        <el-form-item label="示例图名称：" prop="imageName">
          <el-input v-model.trim="formData.imageName" maxlength="10" placeholder="请输入示例图名称" type="text" size="small" />
        </el-form-item>
        <el-form-item v-if="type == '01'" label="是否必填：" prop="isMust">
          <el-radio-group v-model="formData.isMust">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="示例图图片：" prop="sampleImage">
           <!-- @handleChange="sampleHandleChange" -->
          <ElImgUpload
            :isBigImg="true"
            :exist-image="formData.sampleImage"
            placeTxt="提示：图片仅支持上传jpg/png/gif格式，建议尺寸：340-340px"
            @handleChange="sampleHandleChange"/>
        </el-form-item>
        <el-form-item label="拍摄定位框宽高比：" prop="guideBoxRatio">
          <el-select size="small" v-model="formData.guideBoxRatio" placeholder="请选择">
            <el-option
              v-for="item in scaleOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <el-button style="margin-left: 10px;text-decoration: underline;" type="text" @click="showViewer = true">查看示例</el-button>
        </el-form-item>
        <el-form-item label="拍照提示(非必填)：">
          <el-input type="textarea" v-model.trim="formData.sampleTip" placeholder="请输入提示文字，最多50字" maxlength="50" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="visible = false">取消</el-button>
        <el-button type="primary" @click.native="confirm">确定</el-button>
      </span>
    </el-dialog>
    <el-image-viewer v-if="showViewer" :on-close="
      () => {
        showViewer = false;
      }
    " :url-list="imgList" :z-index="99999" />
  </div>
</template>

<script>
import _api from "@/utils/request";
import ElImgUpload from "@/components/global/components/elements/upload-element";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";

const originFormData = {
  imageName: '',
  isMust: '',
  sampleImage: '',
  guideBoxRatio: '',
  sampleTip: ''
}
export default {
  name: "AddSampleImageDia",
  components: { ElImgUpload,ElImageViewer },
  props: {
    position: [String, Number],
    machineTypeId: [String, Number],
    groupId: [String, Number],
  },
  data() {
    return {
      visible: false,

      type: '', // 00示例图 01补充细节图
      formData: originFormData,
      formRule: {
        imageName: [{ required: true, message: '请输入示例图名称', trigger: 'change' }],
        isMust: [{ required: true, message: '请选择是否必填', trigger: 'change' }],
        sampleImage: [{ required: true, message: '请上传图片', trigger: 'change' }],
        guideBoxRatio: [{ required: true, message: '请选择拍摄定位框宽高比', trigger: 'change' }],
      },
      scaleOptions: [{
        value: '00',
        label: '不设置宽高比（无定位框）'
      }, {
        value: '01',
        label: '1:2（手机正面侧面）'
      }, {
        value: '02',
        label: '2:1（手机顶部底部）'
      }, {
        value: '03',
        label: '3:4（平板设备平面）'
      }],
      showViewer: false,
      imgList: ['https://img.fanxinghuishou.cn/20250208/320533332.png'],
    };
  },
  methods: {
    open(type, row) {
      this.type = type
      if (row) {
        this.formData = {
          id: row.id,
          imageName: row.imageName,
          isMust: row.isMust,
          sampleImage: row.sampleImage,
          guideBoxRatio: row.guideBoxRatio,
          sampleTip: row.sampleTip
        }
        console.log(row)
      } else {
        this.formData = JSON.parse(JSON.stringify(originFormData))
      }
      this.$nextTick(() => {
        this.$refs['formRef']?.clearValidate()
        this.visible = true
      })
    },
    close() {
      this.visible = false
    },
    sampleHandleChange(v) {
      this.formData.sampleImage = v
    },
    confirm() {
      this.$refs['formRef'].validate((vaild) => {
        if (vaild) {
          let request = _api.ImageAdd
          if (this.type == '01') request = _api.ImageAddSpecial
          request({
            ...this.formData,
            position: this.position,
            machineTypeId: this.machineTypeId,
            groupId: this.groupId,
          }).then(() => {
            this.$emit('confirm', this.type)
            this.$message.success('操作成功！')
            this.close()
          })
        }
      })
    }
  }
};
</script>